import React from "react";

const MagicInfo = ({ title, image, reverse = false }) => {
  return (
    <section className="container my-2 px-md-5">
      <div className={`row align-items-center ${reverse ? "flex-row-reverse" : ""}`}>
        <div className="col-md-7 d-flex justify-content-center align-items-center">
          <h2
            className="fw-bold mb-3 text-center"
            style={{ color: "#091A4E" }}
          >
            {title}
          </h2>
        </div>
        <div className="col-md-5 text-center">
          <img
            src={image}
            alt={title}
            className="img-fluid rounded shadow-sm"
          />
        </div>
      </div>
    </section>
  );
};

export default MagicInfo;